import React, { FC, ReactNode } from "react";

interface IProps {
  customClass?: string;
  style?: React.CSSProperties;
  children: ReactNode;
  size?: "small" | "medium" | "big";
  color?: string;
  weight?: React.CSSProperties["fontWeight"];
  textAlign?: React.CSSProperties["textAlign"];
}

const Text: FC<IProps> = ({ children, customClass, style, size, color, weight, textAlign }) => {
  return (
    <p
      className={`text ${customClass || ""} ${size || ""}`}
      style={{ ...style, color: color, fontWeight: weight, textAlign }}
    >
      {children}
    </p>
  );
};

export default Text;
